import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as DaTrip from '../_models/daws/trip';

@Injectable({
  providedIn: 'root',
})
// Matches with DA ITripService.cs
export class TripService {
  dataServiceUrl = environment.daUrl;
  constructor(private http: HttpClient) {}

  createTrip(route: DaTrip.Trip): Observable<DaTrip.DataCreated> {
    return this.http.post<DaTrip.Trip>(`${this.dataServiceUrl}trips`, route);
  }

  updateTrip(route: DaTrip.Trip): Observable<DaTrip.DataUpdated> {
    return this.http.put<DaTrip.DataUpdated>(
      `${this.dataServiceUrl}trips/${route.Id}`,
      route
    );
  }

  getTrip(): Observable<Array<DaTrip.Trip>> {
    return this.http
      .get<Array<DaTrip.Trip>>(
        `${this.dataServiceUrl}trips/-1?onlyMine=True&pageSize=1000`
      )
      .pipe(
        map((trips) =>
          trips.filter(
            (trip) =>
              trip?.Profile?.vehicleType === DaTrip.ProfileVehicleType.Auto ||
              trip?.Profile?.vehicleType ===
                DaTrip.ProfileVehicleType.LightDuty ||
              trip?.Profile?.vehicleType === DaTrip.ProfileVehicleType.Truck
          )
        )
      );
  }
  getTripByTripId(routeId: number): Observable<Array<DaTrip.Trip>> {
    return this.http
      .get<Array<DaTrip.Trip>>(`${this.dataServiceUrl}trips/${routeId}`)
      .pipe(map((trips) => trips));
  }
  deleteTrip(routeId: number): Observable<DaTrip.DataUpdated> {
    return this.http.delete<DaTrip.DataUpdated>(
      `${this.dataServiceUrl}trips/${routeId}`
    );
  }
  getUniqueRoute(routeName: string) {
    return this.http
      .get<Array<DaTrip.Trip>>(`${this.dataServiceUrl}trips/-1`)
      .pipe(
        map((trips) =>
          trips.filter((trip) => trip.Name.trim() === routeName.trim())
        )
      );
  }
  createUserDefaultProfile(
    daRouteOptions: DaTrip.RoutingProfile
  ): Observable<DaTrip.DataCreated> {
    return this.http.post<DaTrip.Trip>(
      `${environment.daUrl}routing-profiles`,
      daRouteOptions
    );
  }
}
